import ModalBtn from '../../molecules/modalButton/view';
import { createTax } from '../../../usecases/taxes-usecase';
import { dispatchCustomEvent } from '../../../utils/dispatch';
import TaxForm from '../TaxForm/view';

function NewTax() {
    function handleOpen() {
        // Reset is handled inside TaxForm via its own state initializer on mount
    }

    function handleSubmit(data) {
        createTax(data)
            .then(() => {
                dispatchCustomEvent('popup', { message: 'Impuesto Creado' });
                dispatchCustomEvent('close-new-tax-modal', {});
                dispatchCustomEvent('update-taxes', {});
            })
            .catch(err => {
                if (err.status === 429) {
                    dispatchCustomEvent('popup', { message: 'Alcanzaste el limite' });
                } else {
                    dispatchCustomEvent('popup', {
                        message: err.response?.data?.message || 'Error al crear impuesto',
                        type: 'error',
                    });
                }
                dispatchCustomEvent('loading-btn', {});
            });
    }

    return (
        <ModalBtn
            id="new-tax"
            title="Nuevo Impuesto"
            onClick={handleOpen}
            style={{ border: 'none' }}
        >
            <TaxForm
                onSubmit={handleSubmit}
                loadingId="new-tax-btn"
                title="Crear Nuevo Impuesto"
                submitLabel="Guardar Impuesto"
                modalId="new-tax"
            />
        </ModalBtn>
    );
}

export default NewTax;
